import { useCallback } from 'react';
import { GetMeQuery } from '@/generated/gql/graphql';
import useFeature from '@/lib/features';
import useUserDetails from '@/shared/data/useUserDetails';
import useAccountFeatureConfigs from '@/shared/providers/useAccountFeatureConfigs';
import { isProd } from '@/utils/env';

const useEnablePricing = () => {
  const isProdEnv = isProd();
  const { suppressPricingSuggestions, wasSmbMigrated } = useAccountFeatureConfigs();
  const [enablePricingForAccounts] = useFeature('enterprise-ui_enablePricingForAccounts');
  const { data: segment } = useUserDetails(useCallback((user: GetMeQuery) => user.me?.account?.segment, []));

  // Pricing is explicitly suppressed for this account
  if (suppressPricingSuggestions) {
    return false;
  }

  // In non-prod, pricing is enabled (unless suppressed above)
  if (!isProdEnv) {
    return true;
  }

  // In prod, check if account is eligible via segment or explicit flags
  const isEligibleSegment = segment !== 'Sun';
  return wasSmbMigrated || enablePricingForAccounts || isEligibleSegment;
};

export default useEnablePricing;
